export default "__VITE_ASSET__CXKUsieP__"